import { useTranslation } from "@sagot/i18n";
import { Button, Icon } from "@sagot/ui";
import { useState } from "react";
import { useBuilderTools } from "./builder-tools";
import { NotesEditor } from "./notes-editor";

const N = "engage.workflows.extras.notes";

/**
 * The notes about the workflow as a whole, above the canvas and the list: everyone who edits it reads them first. With
 * none written it is a single line; "Add note" opens the box for one.
 */
export function NotesStrip() {
  const { t } = useTranslation();
  const tools = useBuilderTools();
  const [adding, setAdding] = useState(false);
  if (!tools) return null;
  const own = tools.notesAt(null);
  if (own.length === 0 && !tools.editable) return null;
  return (
    <section className="rounded-lg border border-line bg-surface px-3 py-2" aria-label={t(`${N}.strip`)} data-testid="workflow-notes">
      <div className="flex flex-wrap items-center gap-2">
        <Icon name="sticky-note" className="size-4 text-fg-subtle" />
        <h2 className="text-xs font-bold uppercase tracking-wider text-fg-subtle">{t(`${N}.title`)}</h2>
        <span className="min-w-0 flex-1 text-xs text-fg-subtle">{tools.editable ? t(`${N}.emptyHint`) : null}</span>
        {tools.editable && !adding ? (
          <Button type="button" variant="ghost" size="sm" disabled={!tools.canAddNote} onClick={() => { setAdding(true); }}>
            <Icon name="plus" />
            {t(`${N}.add`)}
          </Button>
        ) : null}
      </div>
      <NotesEditor anchor={null} adding={adding} onDone={() => { setAdding(false); }} className="mt-2" />
    </section>
  );
}
